import { combineReducers } from "redux";
import Mainreducer from "./Mainreducer";
import authReducer from "./authReducer";
import dataReducer from "./dataReducer";


export default combineReducers({
   Mainreducer,
   auth: authReducer,
   data: dataReducer,
})
